/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { CurrentSearchPOIMap } from '@zcode/state-type'
import { handleActions } from 'redux-actions'
import type { ActionTypes } from '../../../reducers/types'
import {
  CLEAR_ALL_POI,
  CLEAR_POI_CATEGORY,
  DONE_FETCHING_POI,
  RECEIVE_POI,
  START_FETCHING_POI,
} from '../constants/index'

const getDefaultValue = () => ({
  data: [],
  meta: {
    fetching: false,
    fetchingKey: null,
    currentKey: null,
  },
})

const getDefaultState = () => ({
  bus_stops: getDefaultValue(),
  cafes: getDefaultValue(),
  groceries: getDefaultValue(),
  nightlife: getDefaultValue(),
  parks: getDefaultValue(),
  rapid_transit_stations: getDefaultValue(),
  restaurants: getDefaultValue(),
  schools: getDefaultValue(),
  train_stations: getDefaultValue(),
})

export const poiReducer = handleActions<CurrentSearchPOIMap, ActionTypes>(
  {
    [CLEAR_ALL_POI]: () => getDefaultState(),
    [CLEAR_POI_CATEGORY]: (state, { payload: { category } }) => {
      return {
        ...state,
        [category]: getDefaultValue(),
      }
    },
    [DONE_FETCHING_POI]: (state, { payload: { category, key } }) => {
      return {
        ...state,
        [category]: {
          ...state[category],
          meta: {
            currentKey: key,
            fetching: false,
            fetchingKey: null,
          },
        },
      }
    },
    [RECEIVE_POI]: (state, { payload: { category, data } }) => {
      const currentPins = state[category].data
      const toAppend = data.filter(
        (d) => !currentPins.find((e) => e.lat === d.lat && e.lng === d.lng)
      )
      return {
        ...state,
        [category]: {
          ...state[category],
          data: currentPins.concat(toAppend),
        },
      }
    },
    [START_FETCHING_POI]: (state, { payload: { category, key } }) => {
      return {
        ...state,
        [category]: {
          ...state[category],
          meta: {
            currentKey: state[category].meta.currentKey,
            fetching: true,
            fetchingKey: key,
          },
        },
      }
    },
  },
  getDefaultState()
)
